import { MenuItemType } from "@/enums";
import { IViperMenuItem } from "@/interfaces";
import { MenuProps } from "antd";
import { ItemType } from "antd/es/menu/interface";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

export const generateMenuItems = (menuItems: IViperMenuItem[]): ItemType[] => {
  const updatedItems: MenuProps["items"] = [];

  const menuItemLink = (menuItem: IViperMenuItem): ReactNode => {
    // External menu item link
    if (menuItem.externalSite) {
      return (
        <a
          href={menuItem.url}
          data-test-id="external-link"
          target="_blank"
          rel="noreferrer"
        >
          {menuItem.title}
        </a>
      );
    }

    // Menu item that's a link, use react router.
    if (menuItem.url) {
      return <Link to={menuItem.url}>{menuItem.title}</Link>;
    }

    // Menu item that isn't actually a link
    return <>{menuItem.title}</>;
  };

  menuItems
    ?.filter((menuItem) => menuItem.visible === undefined || menuItem.visible)
    .forEach((menuItem) => {
      switch (menuItem.type) {
        case MenuItemType.Parent:
          updatedItems.push({
            label: menuItem.title,
            key: menuItem.key,
            disabled: menuItem.disabled,
            children: generateMenuItems(menuItem.children || []),
            icon: menuItem.icon,
          });
          break;
        case MenuItemType.Item:
          updatedItems.push({
            label: menuItemLink(menuItem),
            key: menuItem.key,
            disabled: menuItem.disabled,
            icon: menuItem.icon,
          });
          break;
        case MenuItemType.CustomItem:
          updatedItems.push({
            label: menuItem.customHtml,
            key: menuItem.key,
            disabled: menuItem.disabled,
            icon: menuItem.icon,
          });
          break;
        case MenuItemType.Group:
          updatedItems.push({
            label: menuItem.title,
            key: menuItem.key,
            type: "group",
          });
          break;
        default:
          break;
      }
    });

  return updatedItems;
};
